import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('mnemonics', [
      'mnemonics',
      'mnemonicList',
    ]),
    ...mapGetters('mnemonicStates', [
      'mnemonicStates',
    ]),
    currentMnemonicPosition() {
      return this.currentMnemonics.indexOf(this.currentMnemonic) + 1;
    },
    nextMnemonic() {
      return this.currentMnemonics[this.currentMnemonics.indexOf(this.currentMnemonic) + 1];
    },
    previousMnemonic() {
      return this.currentMnemonics[this.currentMnemonics.indexOf(this.currentMnemonic) - 1];
    },
    currentMnemonic() {
      return this.mnemonics[this.$route.params.mnemonicId] || {};
    },
    currentMnemonics() {
      return this.mnemonicList.filter(m => m.categoryIds.includes(this.currentMnemonicCategory.id)).sort((a, b) => a.number - b.number);
    },
    currentMnemonicCategory() {
      return this.$store.getters['categories/all'].find(c => c.id == this.$route.params.categoryId) || {};
    },
  },
  methods: {
    mnemonicViewed(mnemonic) {
      return this.mnemonicStates[mnemonic.id];
    },
    ...mapActions('mnemonics', [
      'loadMnemonics',
    ]),
    ...mapActions('mnemonicStates', [
      'sendMnemonicState',
    ]),
  },
};
